import React from 'react';
import { Link } from 'react-router-dom';
import { APIPaths } from 'services/api-provider';
import "./footerStyle.css";

const Footer = () => {
  return (
    <footer className='page-footer py-2 is-hidden-mobile is-flex is-justify-content-center'>
      <div className='custom-footer-main'>
        <div>
          <span className='footer-copyrights is-size-7 is-size-6-widescreen'>
            Verison 1.0.0
            {/* Copyright © {new Date().getFullYear()} &nbsp;
            <Link to='/' className='has-text-white is-underlined is-size-7 is-size-6-widescreen'>   ChatCLB   </Link> */}
          </span>
        </div>
        <div className=' ml-5 footer-tags'>
          <a href={`${APIPaths.WebAdminFrontend}`} className='has-text-white is-size-7 is-size-6-widescreen'>    Admin Login   </a>
          <span className='mx-3'>|</span>
          <Link to='/business-pricing' className='has-text-white is-size-7 is-size-6-widescreen'> Business Pricing   </Link>
          <span className='mx-3'>|</span>
          <Link to='/about-us' className='has-text-white is-size-7 is-size-6-widescreen'> About Us  </Link>
          <span className='mx-3'>|</span>
          <Link to='/contact-us' className='has-text-white is-size-7 is-size-6-widescreen'>   Contact Us  </Link>
          <span className='mx-3'>|</span>
          <Link to='/terms-and-conditions' className='has-text-white is-size-7 is-size-6-widescreen'>  Terms and Conditions  </Link>
          <span className='mx-3'>|</span>
          <Link to='/privacy-policy' className='has-text-white is-size-7 is-size-6-widescreen'>  Privacy Policy  </Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
